import Config from '~/client/src/shared/Config'

export default function isTestEnvironment() {
  const ENVIRONMENT = (Config.ENVIRONMENT || '').toLowerCase()
  return ENVIRONMENT === 'development' || ENVIRONMENT === 'qa'
}
